import Indicador from "..";
import { PSMParamFields } from "./components/PSMParamFields";
import PSMEditFields from "./components/PSMEditFields";
import PSMReport from "./reports";
import PSMReportSummary from "./reports/summary";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default class PSM extends Indicador {
    static get fullName() {
        return "Praga de Solo - Múltiplos Parâmetros";
    }

    static get abbrev() {
        return "PSM";
    }

    static get quantifierMeta() {
        return "%";
    }

    static paramFields(tipoIndicadorField = "") {
        return <PSMParamFields tipoIndicadorField={tipoIndicadorField} />;
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <PSMEditFields visita={visita} TipoClass={TipoClass} />;
    }

    async renderReport(visita) {
        return PSMReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return PSMReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat;

        if (!apontamento.coletasPragEnc || !apontamento.coletasTocAt || !apontamento.tocosAvaliados) {
            return 0;
        }

        let totalTocosAvaliados = apontamento.tocosAvaliados || 0;
        let totalTocosAtacados = 0;

        for (const coleta of apontamento.coletasTocAt) {
            let pragaHyponeumaTocAt = 0;
            let pragaCupinsTocAt = 0;
            let pragaMigdolusTocAt = 0;
            let pragaSphenophorusTocAt = 0;

            if (coleta.pragaHyponeumaTocAt) {
                pragaHyponeumaTocAt = f(coleta.pragaHyponeumaTocAt);
            }
            if (coleta.pragaCupinsTocAt) {
                pragaCupinsTocAt = f(coleta.pragaCupinsTocAt);
            }
            if (coleta.pragaMigdolusTocAt) {
                pragaMigdolusTocAt = f(coleta.pragaMigdolusTocAt);
            }
            if (coleta.pragaSphenophorusTocAt) {
                pragaSphenophorusTocAt = f(coleta.pragaSphenophorusTocAt);
            }

            coleta.tocosDanificados =
                pragaHyponeumaTocAt + pragaCupinsTocAt + pragaMigdolusTocAt + pragaSphenophorusTocAt;

            if (coleta.tocosDanificados) totalTocosAtacados += f(coleta.tocosDanificados);
        }

        if (apontamento.coletasTocAt.length && totalTocosAvaliados === 0) {
            apontamento.totalTocosAvaliados = 0;
            apontamento.totalTocosAtacados = 0;
            return 0;
        } else {
            apontamento.totalTocosAvaliados = totalTocosAvaliados;
            apontamento.totalTocosAtacados = totalTocosAtacados;

            return {
                tocosAtacados: totalTocosAtacados,
                tocosAvaliados: totalTocosAvaliados,
            };
        }
    }

    static getConformidadeStatus(conformidade, meta) {
        if (conformidade <= parseFloat(meta)) return "Bom";
        else return "Ruim";
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: "auto", getValue: (a) => a.dataRef.split("-").reverse().join("/") },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: "auto" },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            {
                title: "Talhão",
                field: "talhao.nome",
                getValue: (a) => getTalhaoNomeDisplay(a),
            },
            {
                title: "Área (ha)",
                field: "talhao.area",
                getValue: (a) => getTalhaoAreaDisplay(a),
            },
            { title: "Variedade", field: "variedade.variedade", width: "auto" },
            { title: "Total de Tocos Avaliados", width: "auto", field: "totalTocosAvaliados" },
            { title: "Total de Tocos Danificados", width: "auto", field: "totalTocosDanificados" },
            {
                title: "Conf.(%)",
                field: "conformidade",
                width: "auto",
                getColor: (a) => {
                    return IndicadorClass.getColorStatus(
                        IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta),
                    );
                },
            },
        ];
    }

    static getResultStr(apontamento) {
        return (
            "Total de Tocos Avaliados: " +
            apontamento.totalTocosAvaliados +
            " e Total de Tocos Danificados: " +
            apontamento.totalTocosDanificados
        );
    }
}
